$(function() {
	var conversion = {
		tag: function(link) {
			var reg = new RegExp("^https?:.+\/ppc\/(g|y|dn)\/redirect\/(.+)\/$");
			var matches = link.match(reg);
			if (matches) {
				var frame = $('<iframe>', {src:'/ppc/'+matches[1]+'/redirect/'+matches[2]+'/?type=tag', width:'1px', height:'1px'});
				$('body').append(frame);
			}else{
				var reg = new RegExp("^https?:.+\/redirect\/(.+)\/$");
				var matches = link.match(reg);
				if (matches) {
					var frame = $('<iframe>', {src:'/redirect/'+matches[1]+'/?type=tag', width:'1px', height:'1px'});
					$('body').append(frame);
				}
			}
		}
	}
	
	$('body').on('click', 'a', function(e) {
		var link = $(this).attr('href');
		if (link == '#' || link == '') {
			return true;
		}
		
		e.stopPropagation();
		conversion.tag(link);
	});
	
	$('body').on('click', '.js-clickable', function(e) {
		if (!$(event.target).is('a')) {
			var link = $(this).data('href-blank');
			e.preventDefault();
			conversion.tag(link);
			window.open(link, '_blank');
		}
	});
});